import { createGlobalStyle } from "styled-components";
import { color, flexCenterDir, overflowY } from "./theme";

export const GlobalStyles = createGlobalStyle`
	* {
		margin: 0;
		padding: 0;
		border: none;
		outline: none;
		list-style: none;
		text-decoration: none;
		font-family: Arial, sans-serif, "NotoSansKR";
    color: ${color.white};
	}
	
	body {
		${flexCenterDir}
		background-color: ${color.black};
		-ms-overflow-style: none;
		${overflowY}
	}

	input {
		background-color: rgba(0, 0, 0, 0);
		border: none;
    font-size: 18px;
		color: ${color.white};
    padding: 13px;
    margin-bottom: 1rem;
		
		&::placeholder {
			color: ${color.white};
			font-size: 18px;
      text-align: center;
		}

		&:focus::-webkit-input-placeholder { /* WebKit browsers */
			color:transparent;
		}

		&:focus:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
			color:transparent;
		}

		&:focus::-moz-placeholder { /* Mozilla Firefox 19+ */
			color:transparent;
		}

		&:focus:-ms-input-placeholder { /* Internet Explorer 10+ */
			color:transparent;
		}
	}

	button {
		background: none;
		cursor: pointer;
	}

	#root {
		width: 100vw;
		height: 100vh;
		padding: 0;
	}
`;
